module.exports = __webpack_public_path__ + "img/商業英文.4639ec2a.png";